module.exports = __webpack_public_path__ + "img/重庆梁平双桂湖国家湿地公园@2x.e7051933.png";